module.exports = __webpack_public_path__ + "img/mini program.14ca46d2.png";